import styled from 'styled-components';
import { SidebarItems } from './SidebarItems';
import { NavLink } from 'react-router-dom';
import Clock from './Clock';
import Weather from './Weather/Weather';
import Login from './Login';
import './Sidebar.css';

import { useSelector } from 'react-redux';
import {
  isAuthenticated,
  userName,
} from '../../AppSlice';

import '@fortawesome/fontawesome-free/css/all.css';

const SidebarParent = styled.div`
    padding: 20px 10px 0px 10px;
    flex-grow: 1;
`;

const SidebarItem = styled.div`
  padding: 10px 10px;

  .barImage {
    width: 40px;
    height: 40px;
    border-radius: 20px;
  }

  div {
    color: white;
    font-weight: 600;
    font-size: 1.2rem;
    transition: 0.3s;
  }
  
  &:hover {
    cursor:pointer;
    background-image: linear-gradient(to right, #F0F0F0 , #d3d3d3 );
    border-radius: 10px;
  }

  &:active { 
    transition: background-image 2s; /* For modern browsers */
    background-image: linear-gradient(to right, #F0F0F0 , #a8a8a8 );
  }
  
`;

const SidebarSubItem = styled.div`
margin-left: 40px;  
padding: 10px 10px;

  div {
    color: white;
    font-weight: 600;
    font-size: 1.0rem;
    transition: 0.3s;
  }
  
  &:hover {
    cursor:pointer;
    background-image: linear-gradient(to right, #F0F0F0 , #a8a8a8 );
    border-radius: 10px;
  }

  &:active { 
    transition: background-image 2s; /* For modern browsers */
    background-image: linear-gradient(to right, #F0F0F0 , #a8a8a8 );
  }
  
`;

function Sidebar(props) {
  const isAuth = useSelector(isAuthenticated);
  const user = useSelector(userName);
  return (
    <div className="Sidebar">
      <Clock />
      <SidebarParent>
        {
          SidebarItems.map((item, index) => {
            return (
              <NavLink exact activeClassName="activeSidebarElement" key={item.name} to={item.route} style={{ textDecoration: 'none' }}>
                { item.isSubItem ?
                  (<SidebarSubItem key={item.name} ><div><i className="fas fa-dot-circle"></i> {item.name}</div></SidebarSubItem>)
                  : (<SidebarItem key={item.name} ><div><img className="barImage" src={item.image} alt="" />  {item.name}</div></SidebarItem>)
                }
              </NavLink>
            );
          })
        }
      </SidebarParent>
      <Weather />
      <Login
        isAuthenticated={isAuth}
        authButtonMethod={props.authButtonMethod}
        user={user}
      />
    </div>
  );
}

export default Sidebar;